import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Reducers } from 'store/types'
import { TwoFactorAuthState } from './types'

const initialState: TwoFactorAuthState = {
  twoFactorToken: null,
  challengeExpiry: null
}

export const twoFactorAuthSlice = createSlice({
  name: Reducers.TWO_FACTOR_AUTH,
  initialState,
  reducers: (create) => ({
    setTwoFactorToken: create.reducer(
      (state, action: PayloadAction<{ token: string; expiryMinutes: number }>) => {
        state.twoFactorToken = action.payload.token
        state.challengeExpiry = Date.now() + action.payload.expiryMinutes * 60 * 1000
      }
    ),
    clearTwoFactorToken: create.reducer((state) => {
      state.twoFactorToken = null
      state.challengeExpiry = null
    })
  }),
  selectors: {
    twoFactorAuth: (state) => state
  }
})

export const { setTwoFactorToken, clearTwoFactorToken } = twoFactorAuthSlice.actions

export const { twoFactorAuth } = twoFactorAuthSlice.selectors

export default twoFactorAuthSlice.reducer
